import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { onLoadComplete } from './_utils';

const bodySelector = 'body';
const baseSelector = '.LoadingIndicator';
const forceLoadingIndicator = 'ShowLoadingIndicator';
const hiddenClass = 'is-hidden';
const $bodyTag = $(bodySelector);
const $loadingIndicator = $(baseSelector);

/**
 * Shows the loading indicator.
 */
export function enableLoadingIndicator() {
	$loadingIndicator.removeClass(hiddenClass);
	$loadingIndicator.find('img,video').attr('aria-hidden', '');

	if ($loadingIndicator.length) {
		disableBodyScroll($loadingIndicator[0]);
	}
}

/**
 * Hides the loading indicator.
 */
export function disableLoadingIndicator() {
	$loadingIndicator.addClass(hiddenClass);
	$loadingIndicator.find('img,video').attr('aria-hidden', true);
	if ($loadingIndicator.length) {
		enableBodyScroll($loadingIndicator[0]);
	} else {
		clearAllBodyScrollLocks();
	}
}

export default function initLoadingIndicator() {
	if ($bodyTag.hasClass(forceLoadingIndicator)) {
		// the is-hidden should already not be on the page, but still calling this to lock the scroll
		enableLoadingIndicator();
	} else {
		onLoadComplete(disableLoadingIndicator);
	}
	window.addEventListener('page.dismissLoadingIndicator', disableLoadingIndicator);
	window.addEventListener('page.showLoadingIndicator', enableLoadingIndicator);
}
